import { cloneDeep } from 'lodash';
import { CompositeModel } from '../models/complex/composite.model';
import { ModelOptions } from '../models/options/model-options';
import { PrimitiveModel } from '../models/primitive/primitive.model';
import { isDefined } from './is-defined';

export const assignModelOptions = <T extends PrimitiveModel>(
    model: T,
    options: ModelOptions,
    parentModel?: CompositeModel,
): T => {
    const newModel = cloneDeep(model);

    newModel.options = { ...options };

    if (isDefined(parentModel) && parentModel.value[model.name]) {
        parentModel.set(newModel);
    }

    return newModel;
};
